// @flow
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function SatelliteIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M16.97 4.04c.32.14.59.51.83.76l1.6 1.59c.2.2.68.55.59.9-.1.35-.6.69-.85.95l-2.1 2.1c-.24.24-.7.91-1.09.75-.32-.13-.59-.51-.83-.75l-1.59-1.6c-.2-.2-.71-.55-.65-.88.07-.36.6-.72.84-.96l2.17-2.17c.24-.24.68-.88 1.08-.7z"/>
            <path d="M8.37 5.6c1.05.18 1.77 1.1 2.48 1.8 1.47 1.47 2.9 2.98 4.4 4.4.47.45 1.02.13 1.6.15.98.03 2.37.34 3.03 1.14.33.4-.16.75-.42 1.01l-1.4 1.4c-.18.17-.5.4-.57.64-.1.36.7.83.85 1.15.17.33.08.75-.23.97-.54.38-1.03-.1-1.4-.46-.11-.12-.33-.43-.53-.37-.23.06-.45.4-.61.56l-1.4 1.4c-.2.2-.5.64-.83.6-.3-.02-.53-.43-.67-.66a4.74 4.74 0 01-.72-2.62c.02-.34.23-.9.06-1.2-.27-.53-.93-1-1.35-1.41l-3.25-3.25c-.57-.57-1.3-1.15-1.62-1.91-.73-1.72.67-3.7 2.58-3.35z"/>
            <path d="M7.99 12.88c.31.07.6.5.82.71l1.73 1.72c.19.2.64.51.58.83-.05.25-.35.47-.52.64l-1.4 1.4-1.4 1.4c-.18.18-.42.48-.7.4-.3-.08-.56-.44-.77-.65L4.6 17.6c-.2-.2-.64-.5-.6-.82.02-.26.3-.47.47-.64l1.4-1.4 1.47-1.47c.16-.16.38-.45.64-.39z"/>
            <path d="M0 0h24v24H0z" fill="none"/>
        </SvgIcon>
    );
}

export default SatelliteIcon;